import { HttpResult } from './../../models/API';
import { useAPI } from './useAPI';
import { NavConfig } from 'src/models/configs/navConfig';

// TODO: Move this into model.
interface FooterMapConfigResult extends HttpResult {
    body: {
        data: FooterMapConfigs[],
    }
}

interface FooterMapConfigs {
    config: NavConfig[],
    spm: string,
}

const initData: { data: FooterMapConfigs[] } = {
    data: [],
};

export const useFooterMapConfig = ():  FooterMapConfigs[] => {
    const [res] = useAPI<FooterMapConfigResult["body"]>('//v3.sohu.com/footer/config', initData, []);
    return res.data;
};



// WEBPACK FOOTER //
// ./src/hooks/APIs/useFooterMapConfig.ts